// @flow

import { buSettingsActions } from "./buSettingsActionCreator";

const initialState = {
  buTypes: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  buSettings: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  ticketingUsers: {
    isLoading: false,
    isLoaded: false,
    data: []
  }
};

const buSettingsReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case buSettingsActions.GET_ALL_BU_TYPES: {
      return Object.assign({}, state, { buTypes: action.payload });
    }
    case buSettingsActions.BU_SUBMIT: {
      return Object.assign({}, state, { buSettings: action.payload });
    }
    case buSettingsActions.GET_TICKETING_USERS: {
      return Object.assign({}, state, { ticketingUsers: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default buSettingsReducer;



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/buSettings/buSettingsRedux/buSettingsReducer.js